(function (){
var root = document.querySelector('[data-mk3d]');
if (!root || root.dataset.on || !window.THREE) return;
root.dataset.on = 1;
var T = window.THREE, D = root.dataset;
var stage = root.querySelector('.m3-stage'), tip = root.querySelector('.m3-tip'), yrEl = root.querySelector('[data-m3-year]'),
slider = root.querySelector('input[type=range]'), play = root.querySelector('[data-m3-play]'), list = root.querySelector('[data-m3-top]'),
head = root.querySelector('[data-m3-head]'), tot = root.querySelector('[data-m3-total]'), src = root.querySelector('[data-m3-src]'),
modeBtns = root.querySelectorAll('[data-m3-mode]'), cityBtns = document.querySelectorAll('[data-m3-city]'), title = document.querySelector('[data-m3-title]');
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var C = null, mode = 'be', year = 0, cache = {}, objs = [], maxV = 1;
function f(n, d){return Number(n).toLocaleString('en-CA', {maximumFractionDigits: d || 0, minimumFractionDigits: d || 0 });}
function esc(s){return String(s).replace(/[&<>"']/g, function (c){return '&#' + c.charCodeAt(0) + ';';});}
function js(u){return new Promise(function (ok, no){var s = document.createElement('script'); s.src = u; s.onload = ok; s.onerror = no; document.head.appendChild(s);});}
function getJSON(u){return fetch(u).then(function (r){return r.json();});}
var renderer = new T.WebGLRenderer({antialias: true, alpha: true });
renderer.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));
stage.appendChild(renderer.domElement);
var scene = new T.Scene(); scene.fog = new T.Fog(0x000000, 1100, 2600);
var cam = new T.PerspectiveCamera(42, 1, 1, 6000);
var controls = new T.OrbitControls(cam, renderer.domElement);
controls.enableDamping = true; controls.dampingFactor = 0.08; controls.maxPolarAngle = 1.35; controls.minDistance = 150; controls.maxDistance = 2200;
scene.add(new T.AmbientLight(0x6f86b8, 0.6));
var key = new T.DirectionalLight(0xffffff, 0.9); key.position.set(-300, 700, 400); scene.add(key);
var rim = new T.DirectionalLight(0x4cc2ff, 0.6); rim.position.set(500, 200, -500); scene.add(rim);
var grid = new T.GridHelper(2000, 50, 0x1d3a66, 0x0b1a33); grid.position.y = -0.5; scene.add(grid);
var group = new T.Group(); group.rotation.x = -Math.PI / 2; scene.add(group);
var cA = new T.Color(0x1b4fff), cB = new T.Color(0x4cc2ff), cC = new T.Color(0xffd60a), cD = new T.Color(0xff5a4f);
function ramp(t){
var c = new T.Color();
if (t < 0.4) return c.copy(cA).lerp(cB, t / 0.4);
if (t < 0.75) return c.copy(cB).lerp(cC, (t - 0.4) / 0.35);
return c.copy(cC).lerp(cD, Math.min(1, (t - 0.75) / 0.25));
}
function toronto(){
return Promise.all([window.MKV ? 1 : js(D.to), getJSON(D.ty)]).then(function (r){
var V = window.MKV, y = r[1];
return {name: 'Toronto', unit: '158 neighbourhoods', y0: 2014, ny: 12, per: 1000, lb: ['Home break-ins', 'Car thefts'], src: 'Toronto Police Service, Major Crime Indicators open data. Rates use 2025 neighbourhood populations.', W: V.W, H: V.H,
a: V.h.map(function (h){var v = y.h[String(+h[0])] || []; return {n: h[1], d: h[3], pop: h[2], be: v.slice(0, 12), at: v.slice(12) };}) };
});
}
function area(k){
return getJSON(D['c' + k.replace(/-/g, '')]).then(function (j){
return {name: j.name, unit: j.a.length + ' ' + j.unit, y0: j.y0, ny: j.ny, per: 0, pts: !!j.pts, lb: j.lb, src: j.src + '. Heights show counts, as population by area is not published with the data.', W: j.W, H: j.H,
a: j.a.map(function (r){return {n: r[0], d: r[1], pop: r[2], be: r[3], at: r[4], x: r[5], y: r[6] };}) };
});
}
function country(cc){
var need = [getJSON(D.si)];
if (cc === 'CA' && !window.MKN) need.push(js(D.ca));
if (cc === 'US' && !window.MKU) need.push(js(D.us));
return Promise.all(need).then(function (r){
var ll = {}; r[0].forEach(function (c){ll[c[0]] = [c[4], c[5]];});
var rows = cc === 'CA' ? window.MKN.rows.map(function (x){return {n: x[1] + ', ' + x[2], s: x[5] || x[0], pop: x[3], be: x[6], at: x[10] };})
: window.MKU.r.map(function (x){return {n: x[1] + ', ' + x[2], s: x[0], pop: x[3], be: x[4], at: x[7] };});
rows = rows.filter(function (x){var p = ll[x.s]; return p && p[1] > -130 && p[1] < -52 && p[0] > 24 && p[0] < 62;});
var la = rows.map(function (x){return ll[x.s][0];}), lo = rows.map(function (x){return ll[x.s][1];});
var mnx = Math.min.apply(null, lo), mxx = Math.max.apply(null, lo), mny = Math.min.apply(null, la), mxy = Math.max.apply(null, la), k = Math.cos((mny + mxy) / 2 * Math.PI / 180), sc = 1000 / ((mxx - mnx) * k);
rows.forEach(function (x){var p = ll[x.s]; x.x = (p[1] - mnx) * k * sc; x.y = (mxy - p[0]) * sc;});
return {proj: {mnx: mnx, mxy: mxy, mxx: mxx, mny: mny, k: k, sc: sc }, cc: cc, name: cc === 'CA' ? 'Canada' : 'the United States', unit: rows.length + (cc === 'CA' ? ' police services' : ' cities of 100,000+'), y0: 2015, ny: 11, per: 100000, rate: true, pts: true,
lb: [cc === 'CA' ? 'Break-ins' : 'Burglaries', 'Car thefts'], src: cc === 'CA' ? 'Statistics Canada, police-reported crime by police service. Rates per 100,000 people.' : 'FBI Uniform Crime Reporting via the Crime Data Explorer. Rates per 100,000 people.',
W: 1000, H: (mxy - mny) * sc, a: rows };
});
}
var SRC = {toronto: toronto, chicago: function (){return area('chicago');}, 'new-york': function (){return area('new-york');}, ottawa: function (){return area('ottawa');}, 'york-region': function (){return area('york-region');}, austin: function (){return area('austin');}, canada: function (){return country('CA');}, us: function (){return country('US');} };
function val(o, y){
var arr = mode === 'be' ? o.be : o.at, v = arr ? arr[y - C.y0] : null;
if (v == null) return null;
if (C.rate) return v;
return C.per && o.pop ? C.per * v / o.pop : v;
}
function raw(o, y){var arr = mode === 'be' ? o.be : o.at; return arr ? arr[y - C.y0] : null;}
function unitTxt(){return C.rate ? 'per 100,000 people' : C.per ? 'per 1,000 residents' : 'recorded';}
var base = null, labels = [], lab = document.createElement('div'), libs = null, atlas = null;
lab.style.cssText='position:absolute;inset:0;pointer-events:none;z-index:1;overflow:hidden'; stage.appendChild(lab);
function loadAtlas(){
if (!libs) libs = js('https://cdn.jsdelivr.net/npm/topojson-client@3.1.0/dist/topojson-client.min.js').then(function (){
return Promise.all([getJSON('https://cdn.jsdelivr.net/npm/world-atlas@2.0.2/countries-50m.json'), getJSON('https://cdn.jsdelivr.net/npm/us-atlas@3.0.1/states-10m.json')]);
}).then(function (r){var tj = window.topojson; atlas = {coast: tj.mesh(r[0], r[0].objects.land).coordinates, border: tj.mesh(r[0], r[0].objects.countries, function (a, b){return a !== b;}).coordinates, states: tj.mesh(r[1], r[1].objects.states, function (a, b){return a !== b;}).coordinates };});
return libs;
}
function drawBase(){
if (base){group.remove(base); base.geometry.dispose(); base = null;}
if (!C.proj) return;
var c0 = C;
loadAtlas().then(function (){
if (C !== c0) return;
var p = C.proj, cx = C.W / 2, cy = C.H / 2, pos = [], mx = 4;
function seg(lines){lines.forEach(function (l){for (var i = 1; i < l.length; i++){var a = l[i - 1], b = l[i]; if (a[0] < p.mnx - mx || a[0] > p.mxx + mx || b[0] < p.mnx - mx || b[0] > p.mxx + mx || a[1] < p.mny - mx || a[1] > p.mxy + mx || b[1] < p.mny - mx || b[1] > p.mxy + mx) continue; pos.push((a[0] - p.mnx) * p.k * p.sc - cx, -((p.mxy - a[1]) * p.sc - cy), 0.4, (b[0] - p.mnx) * p.k * p.sc - cx, -((p.mxy - b[1]) * p.sc - cy), 0.4);} });}
seg(atlas.coast); seg(atlas.border); if (C.cc === 'US') seg(atlas.states);
var g = new T.BufferGeometry(); g.setAttribute('position', new T.Float32BufferAttribute(pos, 3));
base = new T.LineSegments(g, new T.LineBasicMaterial({color: 0x5aa9ff, transparent: true, opacity: 0.55 }));
group.add(base);
}).catch(function (){});
}
function setLabels(rows){
lab.innerHTML = ''; labels = [];
rows.forEach(function (r){var d = document.createElement('div'); d.style.cssText='position:absolute;left:0;top:0;padding:3px 7px;border-radius:7px;background:rgba(0,0,0,.7);color:#fff;font-size:12px;white-space:nowrap'; d.innerHTML = '<b>' + esc(r[2].userData.o.n.replace(/, [A-Z]{2}$/, '')) + '</b>'; lab.appendChild(d); labels.push([d, r[2]]);});
}
var tv = new T.Vector3();
function placeLabels(){
var w = stage.clientWidth, h = stage.clientHeight;
labels.forEach(function (L){
var m = L[1], c = m.userData.c;
tv.set(C.pts ? m.position.x : c.x, C.pts ? m.position.y : c.y, m.scale.z + 2); group.localToWorld(tv); tv.project(cam);
var vis = tv.z < 1 && tv.x > -1.1 && tv.x < 1.1 && tv.y > -1.1 && tv.y < 1.1;
L[0].style.display = vis ? '' : 'none';
if (vis) L[0].style.transform = 'translate(' + ((tv.x + 1) / 2 * w).toFixed(1) + 'px,' + ((1 - tv.y) / 2 * h).toFixed(1) + 'px) translate(-50%,-130%)';
});
}
function clear(){
objs.forEach(function (m){group.remove(m); m.geometry.dispose(); m.material.dispose(); m.children.forEach(function (c){c.geometry.dispose(); c.material.dispose();});});
objs = [];
}
function build(){
clear();
var cx = C.W / 2, cy = C.H / 2, colGeo = C.pts ? new T.CylinderGeometry(C.a.length < 30 ? 22 : 3.2, C.a.length < 30 ? 22 : 3.2, 1, 24) : null;
if (colGeo){colGeo.rotateX(Math.PI / 2); colGeo.translate(0, 0, 0.5);}
C.a.forEach(function (o){
var geo;
if (C.pts) geo = colGeo.clone();
else {
var shapes = o.d.split('Z').filter(function (s){return s.trim();}).map(function (s){
return new T.Shape(s.replace('M', '').split('L').map(function (p){var q = p.trim().split(' '); return new T.Vector2(+q[0] - cx, -(+q[1] - cy));}));
});
if (!shapes.length) return;
geo = new T.ExtrudeGeometry(shapes, {depth: 1, bevelEnabled: false });
}
var m = new T.Mesh(geo, new T.MeshStandardMaterial({color: 0x4cc2ff, roughness: 0.5, metalness: 0.1, emissive: 0x0a1f44, emissiveIntensity: 0.6 }));
if (C.pts) m.position.set(o.x - cx, -(o.y - cy), 0);
else m.add(new T.LineSegments(new T.EdgesGeometry(geo, 30), new T.LineBasicMaterial({color: 0x000000, transparent: true, opacity: 0.5 })));
if (!C.pts){geo.computeBoundingBox(); var bb = geo.boundingBox; m.userData.c0 = {x: (bb.min.x + bb.max.x) / 2, y: (bb.min.y + bb.max.y) / 2 };}
m.userData = {o: o, h: 1, target: 1, c: m.userData.c0 };
group.add(m); objs.push(m);
});
var all = [];
objs.forEach(function (m){for (var y = C.y0; y < C.y0 + C.ny; y++){var v = val(m.userData.o, y); if (v != null) all.push(v);} });
all.sort(function (a, b){return a - b;});
maxV = all[Math.floor(all.length * 0.985)] || 1;
slider.min = C.y0; slider.max = C.y0 + C.ny - 1; year = C.y0 + C.ny - 1; slider.value = year;
play.textContent = 'Play ' + C.y0 + ' to ' + year;
head.textContent = 'Highest ' + unitTxt();
src.textContent = 'Source: ' + C.src;
if (title) title.textContent = C.name;
modeBtns[0].textContent = C.lb[0]; modeBtns[1].textContent = C.lb[1];
var span = Math.max(C.W, C.H), wide = stage.clientWidth / Math.max(1, stage.clientHeight) < 1 ? 1.5 : 1;
endPos.set(-span * 0.32 * wide, span * 0.62 * wide, span * 0.72 * wide);
startPos.set(0, span * 1.9, span * 0.08);
drawBase();
t0 = performance.now(); intro = !reduce;
if (reduce) cam.position.copy(endPos);
apply(); kick(); if (M3.onBuild) M3.onBuild();
}
function apply(){
var sum = 0, rows = [], hmax = C.pts ? 260 : 200;
objs.forEach(function (m){
var v = val(m.userData.o, year), t = v == null ? 0 : Math.min(1, v / maxV);
m.userData.target = v == null ? 0.5 : 2 + t * hmax;
m.material.color.copy(v == null ? new T.Color(0x2a2f38) : ramp(t));
m.material.emissive.copy(v == null ? new T.Color(0) : ramp(t)).multiplyScalar(0.18);
var r = raw(m.userData.o, year); if (r != null && !C.rate) sum += r;
if (v != null) rows.push([m.userData.o.n, v, m]);
});
rows.sort(function (a, b){return b[1] - a[1];});
setLabels(rows.slice(0, C.a.length < 15 ? C.a.length : 6));
yrEl.textContent = year;
tot.textContent = C.rate ? 'Each column is one of ' + C.unit + ' on a map of ' + C.name + '. Taller and redder means more ' + modeBtns[mode === 'be' ? 0 : 1].textContent.toLowerCase() + ' per 100,000 people in ' + year + '.' : f(sum) + ' ' + modeBtns[mode === 'be' ? 0 : 1].textContent.toLowerCase() + ' recorded in ' + year + ' across ' + C.unit;
if (M3.onApply) setTimeout(M3.onApply, 0);
list.innerHTML = rows.slice(0, 5).map(function (r, i){return '<li><span>' + (i + 1) + '. ' + esc(r[0]) + '</span><b>' + f(r[1], C.per && !C.rate ? 1 : 0) + '</b></li>';}).join('');
}
var t0 = 0, intro = false, startPos = new T.Vector3(), endPos = new T.Vector3(), vis = true, raf = 0;
function size(){var w = stage.clientWidth, h = stage.clientHeight; renderer.setSize(w, h, false); cam.aspect = w / h; cam.updateProjectionMatrix();}
function frame(now){
raf = 0;
if (intro){var k = Math.min(1, (now - t0) / 2400), e = 1 - Math.pow(1 - k, 3); cam.position.lerpVectors(startPos, endPos, e); if (k >= 1) intro = false;}
objs.forEach(function (m){var d = m.userData; d.h += (d.target - d.h) * (reduce ? 1 : 0.12); m.scale.z = Math.max(0.01, d.h);});
controls.update(); renderer.render(scene, cam); placeLabels();
if (vis) raf = requestAnimationFrame(frame);
}
function kick(){if (!raf) raf = requestAnimationFrame(frame);}
var M3 = window.MK3 = {T: T, cam: cam, controls: controls, group: group, stage: stage, tip: tip, val: val, raw: raw, f: f, esc: esc, kick: kick, objs: function (){return objs;}, cur: function (){return C;}, yr: function (){return year;}, lb: function (){return modeBtns[mode === 'be' ? 0 : 1].textContent.toLowerCase();}, stopIntro: function (){intro = false;}};
var timer = 0;
function stop(){clearInterval(timer); timer = 0; if (C) play.textContent = 'Play ' + C.y0 + ' to ' + (C.y0 + C.ny - 1); play.setAttribute('aria-pressed', 'false');}
play.addEventListener('click', function (){
if (!C) return;
if (timer){stop(); return;}
if (year >= C.y0 + C.ny - 1) year = C.y0;
slider.value = year; apply(); kick();
play.textContent = 'Pause'; play.setAttribute('aria-pressed', 'true');
timer = setInterval(function (){if (year >= C.y0 + C.ny - 1){stop(); return;} year++; slider.value = year; apply();}, 900);
});
slider.addEventListener('input', function (){stop(); year = +slider.value; apply();});
modeBtns.forEach(function (b){
b.addEventListener('click', function (){
mode = b.dataset.m3Mode; modeBtns.forEach(function (x){x.setAttribute('aria-pressed', x === b ? 'true' : 'false');});
if (C) build();
});
});
function open(k){
if (!SRC[k]) k = 'toronto';
stop();
cityBtns.forEach(function (x){x.setAttribute('aria-pressed', x.dataset.m3City === k ? 'true' : 'false');});
tot.textContent = 'Loading police records';
(cache[k] || (cache[k] = SRC[k]())).then(function (c){C = c; build(); try {var u = new URL(location.href); u.searchParams.set('c', k); history.replaceState(null, '', u);} catch (e){} })
.catch(function (){delete cache[k]; tot.textContent = 'The data could not load. Refresh the page to try again.';});
}
cityBtns.forEach(function (b){b.addEventListener('click', function (){open(b.dataset.m3City);});});
if (window.ResizeObserver) new ResizeObserver(size).observe(stage); else window.addEventListener('resize', size);
if ('IntersectionObserver' in window) new IntersectionObserver(function (es){vis = es[0].isIntersecting; if (vis) kick();}).observe(stage);
size();
open(new URLSearchParams(location.search).get('c') || 'toronto');
})();